import { AuthContext } from "context/appContext";
import { ProfilClient } from "data/types";
import { useAppDispatch, useAppSelector } from "hooks/hooks";
import { FC, useContext, useEffect } from "react";
import { Helmet } from "react-helmet";
import { BiSolidBank, BiSolidMessageRoundedDetail } from "react-icons/bi";
import { FaCalendarCheck } from "react-icons/fa";
import { HiOutlineSwitchHorizontal } from "react-icons/hi";
import { HiHome } from "react-icons/hi2";
import { IoCalendarSharp } from "react-icons/io5";
import { getUserStats } from "redux/features/Admin/Stripe/stripeSlice";
import CommonLayout from "./AccountPage/CommonLayout";

import { Card, CardBody, Typography } from "@material-tailwind/react";
import { IoHeart } from "react-icons/io5";
import { Link } from "react-router-dom";

export interface ClientDashboardProps {
  className?: string;
}

const ClientDashboard: FC<ClientDashboardProps> = ({ className = "" }) => {
  const authContext = useContext(AuthContext);

  const dispatch = useAppDispatch();
  let profile = authContext.user?.profil as ProfilClient;
  const is_customer = authContext?.user?.isCustomer;

  useEffect(() => {
    dispatch(
      getUserStats({
        userId: profile?.id,
        account_id: profile?.account_id || "",
        status: profile?.validation || "",
      })
    );
  }, []);
  const stats = useAppSelector((state) => state?.stripe?.ownerStats);
  const subscribedOwnerStats = [
    {
      title: "Mes espaces",
      value: stats?.locationsCount,
      color: "cyan",
      icon: <HiHome className="w-8 h-8" />,
      href: "/client/locations",
    },
    {
      title: "Réclamations",
      value: stats?.reservationsFeedbackCount,
      color: "cyan",
      icon: <BiSolidMessageRoundedDetail className="w-8 h-8" />,
      href: "/client/reclamations-reservations",
    },
    {
      title: "Espaces favoris",
      value: stats?.favoriLocationsCount,
      color: "cyan",
      icon: <IoHeart className={`w-8 h-8 ${stats && stats?.favoriLocationsCount > 0 ? "text-red-500" : ""}`} />,
      href: "/client/espaces-favoris",
    },
    {
      title: "Prestations favoris",
      value: stats?.favoriServicesCount,
      color: "cyan",
      icon: <IoHeart className={`w-8 h-8 ${stats && stats?.favoriServicesCount > 0 ? "text-red-500" : ""}`} />,
      href: "/client/prestataires-favoris",
    },
    {
      title: "Mes événements",
      value: stats?.reservationsCount,
      color: "cyan",
      icon: <FaCalendarCheck className="w-8 h-8" />,
      href: "/client/evenements",
    },
  ];
  const ownerStats = [
    {
      title: "Demandes de réservation",
      value: stats?.pendingReservationsCount,
      color: "cyan",
      icon: <IoCalendarSharp className="w-8 h-8" />,
      href: "/client/list-pending-reservations",
    },
    //
    {
      title: "Mes réservations",
      value: stats?.reservationsCount,
      color: "cyan",
      icon: <FaCalendarCheck className="w-8 h-8" />,
      href: "/client/mes-reservations",
    },
    {
      title: "Transferts",
      value: stats?.transfertsCount,
      color: "cyan",
      icon: <BiSolidBank className="w-8 h-8" />,
      href: "/client/transferts-reservations",
    },
    {
      title: "Transactions",
      value: stats?.transactionsCount,
      color: "cyan",
      icon: <HiOutlineSwitchHorizontal className="w-8 h-8" />,
      href: "/client/transactions",
    },
    {
      title: "Mes espaces",
      value: stats?.locationsCount,
      color: "cyan",
      icon: <HiHome className="w-8 h-8" />,
      href: "/client/locations",
    },
    {
      title: "Réclamations ",
      value: stats?.reservationsFeedbackCount,
      color: "cyan",
      icon: <BiSolidMessageRoundedDetail className="w-8 h-8" />,
      href: "/client/reclamations-reservations",
    },
    {
      title: "Espaces favoris",
      value: stats?.favoriLocationsCount,
      color: "cyan",
      icon: <IoHeart className={`w-8 h-8 ${stats && stats?.favoriLocationsCount > 0 ? "text-red-500" : ""}`} />,
      href: "/client/espaces-favoris",
    },
    {
      title: "Prestations favoris",
      value: stats?.favoriServicesCount,
      color: "cyan",
      icon: <IoHeart className={`w-8 h-8 ${stats && stats?.favoriServicesCount > 0 ? "text-red-500" : ""}`} />,
      href: "/client/prestataires-favoris",
    },
  ];
  const statisticCards = [
    {
      title: "Mes événements",
      value: stats?.reservationsCount,
      color: "cyan",
      icon: <FaCalendarCheck className="w-8 h-8" />,
      href: "/client/evenements",
    },
    {
      title: "Espaces favoris",
      value: stats?.favoriLocationsCount,
      color: "cyan",
      icon: <IoHeart className={`w-8 h-8 ${stats && stats?.favoriLocationsCount > 0 ? "text-red-500" : ""}`} />,
      href: "/client/espaces-favoris",
    },
    {
      title: "Prestations favoris",
      value: stats?.favoriServicesCount,
      color: "cyan",
      icon: <IoHeart className={`w-8 h-8 ${stats && stats?.favoriServicesCount > 0 ? "text-red-500" : ""}`} />,
      href: "/client/prestataires-favoris",
    },
  ];

  const combinedStats =
    profile?.validation === "approuvé" && is_customer !== true
      ? ownerStats
      : profile?.validation === "approuvé" && is_customer === true
        ? subscribedOwnerStats
        : statisticCards;

  return (
    <div className={`nc-AccountPage ${className}`} data-nc-id="AccountPage">
      <Helmet>
        <title>EventToBee | Location d'espaces : salles, lofts, jardins & boutiques – Paris & Île-de-France</title>
      </Helmet>

      <CommonLayout>
        {/* <div className="font-bold text-center">Tableau de bord</div> */}

        <div className="space-y-6 sm:space-y-8">
          <div className="container max-w-6xl px-5 mx-auto my-28">
            <div className="grid gap-7 sm:grid-cols-2 lg:grid-cols-4">
              {combinedStats.map((card) => (
                <Link to={card?.href} key={card?.title}>
                  <Card className="shadow-xl h-24  border border-gray-200 transition duration-1000 ease-in-out !rounded-lg flex flex-col group  bg-eventToBee">
                    <CardBody className="flex flex-col justify-between flex-1 p-4 !rounded-lg  ">
                      <div className="flex items-center justify-between">
                        <Typography className="!font-semibold text-base  text-white  ">{card.title}</Typography>
                        <div className="flex items-center gap-1 text-white">{card.icon}</div>
                      </div>
                      <div className="mt-auto">
                        <Typography color="blue-gray" className="font-semibold text-white">
                          {card.value ?? ""}
                        </Typography>
                      </div>
                    </CardBody>
                  </Card>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </CommonLayout>
    </div>
  );
};

export default ClientDashboard;
